import { Injectable, NgModule } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { VwApiRequestsService, VwApiResponse, VW_ERROR_CODES } from 'vwappservices';
import { NumberFormatMode } from 'src/app/shared/utils/app-format.util';

@Injectable({
  providedIn: 'root'
})
export class DataManipService {

  private subject = new Subject<any>();
  private applevelmsg = new Subject<any>();
  private updateCurrRates = new Subject<any>();
  public sendObj: any = "";
  public sendObjfromAcc: any = "";
  public viewObj: any = ''
  public loginData: any = {};
  public paymentDetails: any = {};

  // loginData is only ever set in-memory at login (see login-page.component.ts) — a hard
  // refresh on any deep route keeps the user's auth token (restored by authGuard) but wipes
  // this, crashing DefaultHeaderComponent's `userName.substring(...)`. Mirror it into
  // sessionStorage so the guard can rehydrate it after a token-only session restore.
  persistLoginData(): void {
    try {
      sessionStorage.setItem('loginData', JSON.stringify(this.loginData));
    } catch {
      // sessionStorage unavailable (e.g. private browsing) — non-fatal, just won't survive a refresh
    }
  }

  restoreLoginDataIfMissing(): void {
    if (this.loginData?.username) return;
    try {
      const stored = sessionStorage.getItem('loginData');
      if (stored) this.loginData = JSON.parse(stored);
    } catch {
      // ignore malformed/unavailable storage — caller still has the empty default
    }
  }

  // System Parameters — global display format, read at login (see login-page.component.ts)
  // and read by every AppDatePipe / AppNumberPipe transform + formatAppDate/formatAppNumber call site.
  public dateFormat: string = 'dd-mm-yyyy';
  public numberFormat: NumberFormatMode = 'indian';
  // A hard refresh (or a fresh tab landing on a deep route) restores the auth token but
  // creates a brand-new DataManipService instance, wiping this back to the hardcoded default
  // above — that's the bug this flag exists to close: authGuard's rehydration path calls
  // loadFormatSettings() unconditionally on every check, and this makes that a cheap no-op
  // once already loaded this session (mirrors restoreLoginDataIfMissing's own early-return),
  // instead of only ever loading it from the interactive login form.
  private formatSettingsLoaded = false;
  /**testing*/
  private msgSource = new BehaviorSubject('default message');
  currentMsg = this.msgSource.asObservable();
  /**testing*/
  private catDdlSub = new Subject<any>();
  /**
   * This object can use to share data from one page to another page to perform Add/Edit operations.
   * Below Object is defined by the Jagdish and first time used on RD Expenses screen.
   */

  addEditDataObj:any = {};

  constructor(private http: HttpClient, private apiEncryption: VwApiRequestsService) { }

  async loadFormatSettings() {
    if (this.formatSettingsLoaded) return;
    const res: VwApiResponse = await this.apiEncryption.postAPICall('common/getsysparameters', {});
    if (res['errorCode'] === VW_ERROR_CODES.SUCCESS) {
      const data = res['Data'] || {};
      if (data['dateformat']) this.dateFormat = data['dateformat'];
      if (data['numberformat']) this.numberFormat = data['numberformat'];
      this.formatSettingsLoaded = true;
    }
  }


  sendObject(message: object) {
    // console.log("before publishing next method");
    this.subject.next({ message });
    // console.log("after publishing next method");
  }

  sendCatDdlData(message: object) {
    this.catDdlSub.next(message);
  }

  sendCurrRates(currrates: any[]) {
    this.updateCurrRates.next(currrates);
  }

  sendAppLevelMsg(message: object) {
    // console.log("before publishing next method");
    this.applevelmsg.next({ message });
    // console.log("after publishing next method");
  }

  clearObject() {
    // this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }


  getCurrRates() {
    return this.updateCurrRates.asObservable();
  }

  getCatDdlData(): Observable<any> {
    return this.catDdlSub.asObservable();
  }

  getAppLevelMsg(): Observable<any> {
    return this.applevelmsg.asObservable();
  }
  /*********ends here**********/

  changeMsg(message: any) {
    this.msgSource.next(message);
  }

 
}
